import React from 'react'

import Delivery from './Delivery'
import Devan from './Devan'
import {
  TabLabelKey,
  useScheduleActions,
  useScheduleState
} from './stores/useScheduleStore'

import Tabs from '@/components/common/Tabs'

const Schedule: React.FC = () => {
  const { tabLabels, activeTab } = useScheduleState()
  const { changeTabLabel } = useScheduleActions()

  return (
    <div className="bg-white h-full p-4 shadow-md">
      {/* 标签导航 */}
      {tabLabels.length > 0 && (
        <div className="flex-shrink-0">
          <Tabs
            options={tabLabels}
            activeValue={activeTab}
            onChange={(key) => changeTabLabel(key as TabLabelKey)}
          />
        </div>
      )}

      {/* 打印预览模态框 */}
      {/* <PrintPreview /> */}

      <div className="flex-1 overflow-auto">
        {/* 预约拆柜 */}
        {activeTab === 'devan' && <Devan />}
        {/* 预约搬出 */}
        {activeTab === 'delivery' && <Delivery />}
      </div>
    </div>
  )
}

export default Schedule
